import {useEffect, useState} from "react";
import {setSolarEngineAppMode} from "./utils/solarEngine";
import App from "./App";
import LoadingScreen from "./components/LoadingScreen";
import MobileApp from "./mobile/MobileApp";

const MOBILE_BREAKPOINT = 1366;

function isMobileViewport() {
    return window.innerWidth < MOBILE_BREAKPOINT;
}

export default function ResponsiveApp() {
    const [isMobile, setIsMobile] = useState(isMobileViewport);
    const [mobileLoadingProgress, setMobileLoadingProgress] = useState(0);
    const [isMobileLoading, setIsMobileLoading] = useState(isMobileViewport);

    useEffect(() => {
        const handleResize = function () {
            setIsMobile(isMobileViewport());
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        setSolarEngineAppMode(isMobile ? "h5" : "pc");
    }, [isMobile]);

    useEffect(() => {
        if (!isMobile) {
            setIsMobileLoading(false);
            return undefined;
        }
        let progress = 0;
        setMobileLoadingProgress(0);
        setIsMobileLoading(true);
        const timerId = window.setInterval(function () {
            progress = Math.min(100, progress + 2);
            setMobileLoadingProgress(progress);
            if (progress >= 100) {
                window.clearInterval(timerId);
                window.setTimeout(function () { setIsMobileLoading(false); }, 1000);
            }
        }, 70);
        return () => window.clearInterval(timerId);
    }, [isMobile]);

    if (isMobile) {
        return (
            <>
                <MobileApp/>
                {isMobileLoading ? <LoadingScreen progress={mobileLoadingProgress}/> : null}
            </>
        );
    }
    return <App/>;
}
